<template>
    <v-dialog v-model="dialogAjoutData" width="auto" >
        <!-- :text="`${props.articleRepart.type=='color'?'Modification de la répartition couleur ':'Modification de la répartition de la référence '}`" -->
        <v-card 
        prepend-icon="mdi-book-edit"
          
          title="Ajouter"
        >
            <v-card-text v-if="loading">
                <v-row v-if="loading" justify="center" align="center"  class="mt-4">
                    <v-col cols="12" class="text-center">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="64"
                        ></v-progress-circular>
                        <p class="mt-4 text-body-1">Chargement des données...</p>
                    </v-col>
                </v-row>

            </v-card-text>
            <v-card-text class="scroll-box" v-if="!loading">
                 <div  class="input-group input-group-sm mb-3" style="margin-top: 5px;">
                    <input size="5"  v-model="rechercher"  class="form-control form-control-sm" type="text">
                     <!-- :style="[rechercherArticleStatut.statut?{'color':'red'}:{}]">  -->
                </div>
                
                <div class="input-group input-group-sm mb-3" style="position: sticky;text-align: center;  top: 0;  z-index: 2;margin-top: 1px;">
                    <div style="width: 50px;" ></div>
                    <div style="width: 70px;background-color: antiquewhite;text-align: center;" >Code</div>
                    <div style="width: 200px;background-color: antiquewhite;text-align: center;" >Libellé</div>
                </div>
                <div  style="margin-top: 1px;">
                    <div  class="input-group input-group-sm mb-3" >
                        <button :disabled="founded.id||dataToAdd.description==''" @click="addData()" style="width: 50px;" class="btn-new btn btn-outline-secondary"  type="button" id="button-addon1"><v-icon icon="mdi-plus" ></v-icon></button>
                        <input  v-model="dataToAdd.id" @input="dataToAdd.id = dataToAdd.id.toUpperCase()" style="width: 70px;" class="form-control form-control-sm" type="text" >
                        <input   v-model="dataToAdd.description"  style="width: 200px" class="form-control form-control-sm" type="text" > 
                    </div>
                    <v-chip @click="dataToAdd.id=idProp.id;idProp.statut=false;idProp.id=''" v-if="!founded.id&&idProp.statut&&idProp.id" size="x-small" color="green" style="margin-top: -30px;margin-left: 50px;"><span><b>{{ idProp.id }}</b></span></v-chip>
                    <br v-if="founded.description&&!idProp.statut" /><v-chip v-if="founded.description" size="x-small" color="red" style="margin-top: -35px;margin-left: 50px;"><span><b>{{founded.code.description}}</b> existe avec le code <b>{{ founded.code.id }}</b></span></v-chip>
                    <br v-if="founded.id&&!idProp.statut" /><v-chip v-if="founded.id" size="x-small" color="red" style="margin-top: -35px;margin-left: 50px;"><span><b>{{founded.code.id}}</b> existe avec le libellé <b>{{ founded.code.description }}</b></span></v-chip>
                </div>
                <div v-for="item in itemsDataFiltred" style="margin-top: 1px;">
                    <div  class="input-group input-group-sm mb-3">
                        <button  style="width: 50px;" @click="updateData(item)" class="btn btn-outline-secondary" type="button" id="button-addon1"><v-icon icon="mdi-refresh" ></v-icon></button>
                        <input disabled v-model="item.id  " style="width: 70px;" class="form-control form-control-sm" type="text" >
                        <input   style="width: 200px" v-model="item.description"  class="form-control form-control-sm" type="text" >
                    </div>
                </div>
                
            </v-card-text>
        </v-card> 
    </v-dialog>
    

</template>
<script setup>
import axios from 'axios'
import { onMounted,  ref, computed, watch } from 'vue'
import store from '../store'

const props = defineProps({
  modelValueData: {
    type: Boolean,
    default: false
  },
  typeDataToAdd:{
    type: Object
  },
  codemarque:{
    type:String
  }
})
const emit = defineEmits(['update:modelValue', 'validate'])
let dataToAdd=ref({id:'',description:''})
// Référence du dialogue
const dialogAjoutData = computed({
  get: () => props.modelValueData,
  set: (value) => emit('update:modelValue', value)
})
let loading=ref(false)
let itemsDataFiltred=ref([])
let itemsData=ref([])
async function addData(){
    let data={id:dataToAdd.value.id,description:dataToAdd.value.description,shortDescription:dataToAdd.value.description}
    itemsData.value.unshift(data)
    sendData(data)
    checkID()
    getNewId()
}
let rechercher=ref()
watch(rechercher,()=>{
    let regex = new RegExp(rechercher.value, "i")

        itemsDataFiltred.value=itemsData.value.filter(el=>(`${el.id}${el.description}`).match(regex))
    
})
let founded=ref({id:false,description:false})
let idProp=ref({id:false,statut:false})
watch(
    () => dataToAdd.value.id,
        () => {

            founded.value.id=checkID().statut
            if(props.typeDataToAdd.id=='2' && props.typeDataToAdd.tableId=='tableId'){
                idProp.value.id=genererProchainIdPrefixe(itemsData.value.filter(el=>el.id.match(new RegExp(`^${dataToAdd.value.id}`,'gmi'))))
                idProp.value.statut=true
            }
            
            
        },
        { immediate: true }
)

watch(
    () => dataToAdd.value.description,
        () => {
            founded.value.description=checkDescription().statut 
        },
        { immediate: true }
)
async function getNewId(){
  console.log(itemsData.value)
    if(props.typeDataToAdd.id=='2' && props.typeDataToAdd.tableId=='tableId'){
        
        dataToAdd.value.id=genererProchainId(itemsData.value)
        dataToAdd.value.description=''
    }
    else{
        let id=1
        while(itemsData.value.find(el=>el.id.toString().replace(/\D/g, '')==id)){
            id++
        }
        dataToAdd.value.id=id
        dataToAdd.value.description=''
    }
    
    
}
function tailleLaPlusRepetee(arr) {
  const compteur = {};
  if(arr.length>0){
    arr.forEach(item => {
        const taille = item.toString().length;
        compteur[taille] = (compteur[taille] || 0) + 1;
    });
    return Object.keys(compteur).reduce((a, b) => compteur[a] > compteur[b] ? parseInt(a) : parseInt(b))
  } else {
    return 1
  }
  
}
function genererProchainId(themeTab) {
  // Si le tableau est vide, retourner un ID avec un préfixe par défaut (car on ne sait pas)
  if (!themeTab || themeTab.length === 0) {
    return null; // ou lancez une erreur
  }
  
  // Compter les préfixes (TOUS les préfixes, y compris ceux sans numéros)
  const compteur = {};
  const prefixesAvecNumeros = new Set();
  
  themeTab.forEach(item => {
    const match = item.id.match(/^([A-Za-z]+)/);
    
    if (match) {
      const prefix = match[1];
      const hasNumber = match[2] !== '';
      
      // Compter toutes les occurrences
      compteur[prefix] = (compteur[prefix] || 0) + 1;
      
      // Marquer ceux qui ont des numéros
      if (hasNumber) {
        prefixesAvecNumeros.add(prefix);
      }
    }
  });
  // Trouver le préfixe le plus fréquent PARMI CEUX QUI ONT DES NUMÉROS
  let prefixMax = '';
  let maxCount = 0;
  for (const [prefix, count] of Object.entries(compteur)) {
    // Ne garder que les préfixes qui ont au moins un élément avec numéro
    if (prefixesAvecNumeros.has(prefix) && count > maxCount) {
      maxCount = count;
      prefixMax = prefix;
    }
  }
  
  // Si aucun préfixe avec numéro n'existe, prendre le préfixe le plus fréquent
  if (!prefixMax) {
    for (const [prefix, count] of Object.entries(compteur)) {
      if (count > maxCount) {
        maxCount = count;
        prefixMax = prefix;
      }
    }
  }
  
  // Vraiment aucun préfixe ? (cas improbable)
  if (!prefixMax) {
    return null;
  }
  // Extraire les numéros existants pour ce préfixe
  const numeros = themeTab
    .map(item => {
      const match = item.id.toString().trim().match(new RegExp(`^${prefixMax}(\\d+)`));
      return match ? Number(match[1]) : null;
    })
    .filter(n => n !== null)
    .sort((a, b) => a - b);
    // console.log(numeros);
    
  let taille=tailleLaPlusRepetee(numeros)
  // Trouver le prochain numéro
  let prochainNumero = 1;
  if (numeros.length > 0) {
    for (let i = 1; i <= numeros.length + 1; i++) {
      if (!numeros.includes(i)) {

            prochainNumero = i;

        
        break;
      }
    }
  }
  
  return `${prefixMax}${prochainNumero.toString().padStart(taille, '0')}`;
}
function genererProchainIdPrefixe(themeTab) {
//   console.log(prefixe);
    
  // Si le tableau est vide, retourner un ID avec un préfixe par défaut (car on ne sait pas)
  if (!themeTab || themeTab.length === 0) {
    return null; // ou lancez une erreur
  }
  
  // Compter les préfixes (TOUS les préfixes, y compris ceux sans numéros)
//   let regex = new RegExp(`^${prefixe}`,'gmi')
  const compteur = {};
  const prefixesAvecNumeros = new Set();
  
  themeTab.forEach(item => {
    const match = item.id.match(/^([A-Za-z]+)/);
    // const match1 = item.id.match(/^([A-Za-z]+)/);
    // console.log(match1);
    if (match) {
        
        
      const prefix = match[0];
      const hasNumber = match[1] !== '';
      
      // Compter toutes les occurrences
      compteur[prefix] = (compteur[prefix] || 0) + 1;
      
      // Marquer ceux qui ont des numéros
      if (hasNumber) {
        prefixesAvecNumeros.add(prefix);
      }
    }
  });
  // Trouver le préfixe le plus fréquent PARMI CEUX QUI ONT DES NUMÉROS
  let prefixMax = '';
  let maxCount = 0;
  for (const [prefix, count] of Object.entries(compteur)) {
    // Ne garder que les préfixes qui ont au moins un élément avec numéro
    if (prefixesAvecNumeros.has(prefix) && count > maxCount) {
      maxCount = count;
      prefixMax = prefix;
    }
  }
  
  // Si aucun préfixe avec numéro n'existe, prendre le préfixe le plus fréquent
  if (!prefixMax) {
    for (const [prefix, count] of Object.entries(compteur)) {
      if (count > maxCount) {
        maxCount = count;
        prefixMax = prefix;
      }
    }
  }
  
  // Vraiment aucun préfixe ? (cas improbable)
  if (!prefixMax) {
    return null;
  }
  // Extraire les numéros existants pour ce préfixe
  const numeros = themeTab
    .map(item => {
      const match = item.id.match(new RegExp(`^${prefixMax}(\\d+)`));
      return match ? Number(match[1]) : null;
    })
    .filter(n => n !== null)
    .sort((a, b) => a - b);
    let taille=tailleLaPlusRepetee(numeros)
  // Trouver le prochain numéro
  let prochainNumero = 1;
  if (numeros.length > 0) {
    for (let i = 1; i <= numeros.length + 1; i++) {
      if (!numeros.includes(i)) {

            prochainNumero = i;

        
        break;
      }
    }
  }
  
  return `${prefixMax}${prochainNumero.toString().padStart(taille, '0')}`;
}


async function updateData(data){
    
    
    sendData(data)
    if(data.description!=''){
        itemsDataFiltred.value.map(el=>{
            if(el.id==data.id)
            {el.description=data.description}
        })
        itemsData.value.map(el=>{
            if(el.id==data.id)
            {el.description=data.description}
        })
    }
    
}
async function getData(){
    loading.value=true
    if(props.typeDataToAdd.id=='2' && props.typeDataToAdd.tableId=='tableId'){
        itemsData.value=store.state.themes.filter(el=>el.split('|')[1].trim()==props.codemarque).map(el=>el={id:el.split('|')[0].trim().split('-')[0],description:el.split('|')[0].trim().split('-')[1]}).sort((a, b) =>b.id.replace(/\D/g, '') - a.id.replace(/\D/g, ''))
        itemsDataFiltred.value=itemsData.value
        getNewId()
    }else{
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `/cegid-api/Y2/98661025_001_PROD/api/${props.typeDataToAdd.url}`, //
            headers: { 
                'Authorization' : `Bearer ${store.state.token_y2}`, 
                'Content-Type'  : 'application/json'
            }
        };
        axios.request(config)
        .then((response) => {
            itemsData.value=response.data.values.sort((a, b) =>  b.id - a.id)
            itemsDataFiltred.value=itemsData.value
            getNewId()
            
        })
        .catch((error) => {
        })
    }
    loading.value=false
    
}
function checkID() {
    // Vérifier si dataToAdd.value existe et a un id
    if (!dataToAdd.value || !dataToAdd.value.id) {
        return {
            statut: false,
            color: { color: 'green' }
        };
    }

    // Vérifier si itemsData.value existe et est un tableau
    if (!itemsData.value || !Array.isArray(itemsData.value)) {
        return {
            statut: false,
            color: { color: 'green' }
        };
    }
    let regex = new RegExp(`^${dataToAdd.value.id}$`)
    const exists = itemsData.value.find(item => item.id.toString().trim().match(regex));
    if (exists) {
        founded.value.code=exists
        return {
            statut: true,
            color: { color: 'red' }
        };
    } else {
        return {
            statut: false,
            color: { color: 'green' }
        };
    }
}
function checkDescription() {
    // Vérifier si dataToAdd.value existe et a un id
    if (!dataToAdd.value || !dataToAdd.value.description) {
        return {
            statut: false,
            color: { color: 'green' }
        };
    }

    // Vérifier si itemsData.value existe et est un tableau
    if (!itemsData.value || !Array.isArray(itemsData.value)) {
        return {
            statut: false,
            color: { color: 'green' }
        };
    }
    let regex = new RegExp(dataToAdd.value.description,'gmi')
    const exists = itemsData.value.find(item => item.description.toString().trim().match(regex));
    if (exists) {
        founded.value.code=exists 
        return {
            statut: true,
            color: { color: 'red' }
        };
    } else {
        return {
            statut: false,
            color: { color: 'green' }
        };
    }
}
async function sendData(data){
    data={...data,[props.typeDataToAdd.tableId]:props.typeDataToAdd.id}
    // console.log(data);
    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `/cegid-api/Y2/98661025_001_PROD/api/${props.typeDataToAdd.url}/${data.id}`, //
        headers: { 
        'Authorization': `Bearer ${store.state.token_y2}`, 
        'Content-Type': 'application/json'
        },
        data:data
    };
    axios.request(config)
    .then((response) => {
        // console.log(response);
      
    })
    .catch((error) => {
    })
}
onMounted(()=>{
    getData()
})
</script>
<style scoped>
.btn-new {
    position: relative;
    display: inline-block;
    padding: 3px 12px;
    width: 250px;
    text-decoration: none;
    border-radius: 4px;
    font-family: Arial, sans-serif;
    font-weight: bold;
    overflow: hidden;
}

.btn-new::before {
    content: "new";
    position: absolute;
    top: 0px;
    right: -23px;
    background-color: #ff4757;
    color: white;
    padding: 0px 20px;
    font-size: 7px;
    font-weight: bold;
    transform: rotate(45deg);
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}</style>